import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';

var freleaseSignupForm = function (classname, form) {
  const $form = $(form);
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const userEmail = $form.find('input[name^="email"]').val();
  const firstName = $form.find('.first-name-form').val();
  const lastName = $form.find('.last-name-form').val();
  const phoneNumber = $form.find('.phone-form').val();
  const companyName = $form.find('.company-form').val();
  const emailHash = SiteUtilities.getShaHash(userEmail);
  const geoLocation = LocationUtilities.getGeoLocation();
  const redirect = $form.attr('data-redirect');
  const signUpApiUrl = $form.data('signup-url') || 'https://www.freshrelease.com/signup';
  const remindEndPoint = 'https://www.freshrelease.com/find_domain?user_email=';
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(userEmail, fmAssetId, tacticId);
  const gclid = SiteUtilities.getGclId();

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = SiteUtilities.getCombinedGaClientId(gclid, compositeKey);
  }

  const country = geoLocation ? geoLocation.countryName : '';
  const data = {
    signup: {
      user_email: userEmail,
      validate_duplicate: true,
      time_zone: `${sessionObj.time.tz_offset}`,
      user_first_name: firstName,
      user_last_name: lastName,
      user_phone: phoneNumber,
      user_company: companyName,
      user_name: `${firstName} ${lastName}`
    },
    gdpr_first_opt_in: ($form.find('input[name="send_promotions"]').is(':checked')),
    country: country,
    session_json: sessionObj,
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || SiteUtilities.getCurrentLocation()),
    first_landing_url: Cookie.get('fw_flu') || '',
    pre_visits: Cookie.get('fw_vi') || 0,
    source: `${SiteUtilities.getParameterByName('utm_source')}`,
    medium: `${SiteUtilities.getParameterByName('utm_medium')}` || '',
    campaign: `${SiteUtilities.getParameterByName('utm_campaign')}` || '',
    fs_cookie: freshsales.anonymous_id || 'Not found'
  };

  if (sessionObj.current_session.referrer === '' && data.source === '') {
    data.source = 'Direct';
  } else if (sessionObj.current_session.referrer !== '' && data.source === '') {
    data.source = sessionObj.current_session.referrer;
  }
  SiteUtilities.configureAssetId($form, 'frelease');
  // Post to freshmarketer.
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: userEmail,
      phone: phoneNumber || '',
      company: companyName,
      country: country || '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fservicefirstreferrer: Cookie.get('fw_flu') || '',
        cf_fservicesignupreferrer: window.location.href || '',
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      composite_stitching_key: compositeKey
    }
  };

  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    data: JSON.stringify(data),
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json',
    success: (response) => {
      if (response.success && response.url) {
        freshmarketerData.freshmarketerObject.domainUrl = response.url;
        freshmarketerData.freshmarketerObject.accountId = response.id;
        freshmarketerData.freshmarketerObject.product = 'Freshrelease';
        GA4Utilities.ga4ThankYouEvent(response.id, response.url, $form);
        GA4Utilities.fwFormSubmit(classname, { comapny: companyName, email: userEmail, firstName, lastName, phone: phoneNumber });
        SiteUtilities.passSignupResponseToGA(response.id, response.url, 'Freshrelease');
        SiteUtilities.freshmarketerPost(freshmarketerData, false, form).then(function () {
          jQuery('body').trigger('trackingCompleted');
        });
        jQuery('body').on('trackingCompleted', () => {
          localStorage.setItem('redirect_url', response.url);
          let thankYouRedirect = `${redirect}?account_id=${response.id}&redirect_url=${encodeURIComponent(response.url)}&ehash=${emailHash}`;
          if (isExternalIframeSignup) {
            thankYouRedirect += '&post_to_partner=true';
            if (currentReferrer) {
              thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
            }
          }
          window.location.href = thankYouRedirect;
        });
      }
    },
    error: (xhr, status, err) => {
      if (xhr.responseText.includes('multiple_signup_detected')) {
        GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
        $('.login-trigger-button.frelease').trigger('click');
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        $('.email-reminder-button').on('click', function () {
          $.ajax({
            url: `${remindEndPoint}${encodeURIComponent(userEmail)}`,
            type: 'GET',
            accept: 'application/json; charset=UTF-8',
            contentType: 'application/json; charset=UTF-8',
            success: (response) => {
              $('.form-field-container,.thank-you-card').addClass('active');
            }
          });
        });

        $('.new-account-button').on('click', function () {
          $(this).addClass('button--loading product-specific');
          data.signup['validate_duplicate'] = false;
          $.ajax({
            url: signUpApiUrl,
            type: 'POST',
            data: JSON.stringify(data),
            accept: 'application/json; charset=UTF-8',
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json',
            success: (response) => {
              if (response.success && response.url) {
                localStorage.setItem('redirect_url', response.url);
                let thankYouRedirect = `${redirect}?account_id=${response.id}&redirect_url=${encodeURIComponent(response.url)}&ehash=${emailHash}`;
                if (isExternalIframeSignup) {
                  thankYouRedirect += '&post_to_partner=true';
                  if (currentReferrer) {
                    thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
                  }
                }
                window.location.href = thankYouRedirect;
              }
            }
          });
        });
      }
    },
    complete: () => {
      $form.find('.button').removeClass('button--loading').attr('disabled', null);
    }
  });
};

export default {
  freleaseSignupForm
};
